/** /ko/virtual-office — Korean pillar, independently authored copy. */
import { createFileRoute } from "@tanstack/react-router";
import { VO_LOCALE_PILLARS } from "@/data/virtual-office/locale-pillar";
import { voLocaleHead } from "@/lib/virtual-office/locale-head";
import { VoLocalePillarPage } from "@/components/virtual-office/VoLocalePillar";

const P = VO_LOCALE_PILLARS.ko;

export const Route = createFileRoute("/ko/virtual-office")({
  loader: () => ({ h: voLocaleHead(P) }),
  head: ({ loaderData }) => loaderData?.h ?? {},
  component: () => <VoLocalePillarPage p={P} />,
});
